import { QtyDetail } from './qty-detail';

export class LocationQtyDetail {

     constructor(
        public locationId: number,
        public productId: number,
        public details: QtyDetail
     ) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/location-qty-detail.ts